/**
 * @desc pushedToSystemOrderByUpdateAt
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  params: API.walmart.test.pushedToSystemOrderByUpdateAt.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/test/pushedToSystemOrderByUpdateAt`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
